module.exports = __webpack_public_path__ + "img/img-prestacao-de-contas.4660c217.png";